import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-116">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-117">
        <a href="#" className="text-2xl font-bold" data-id="element-118">
          <span className="text-indigo-600" data-id="element-119">OTO</span> PR9
        </a>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-120">
          {['Home', 'About', 'Skills', 'Projects', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="font-medium hover:text-indigo-600 transition-colors" data-id="element-121">
              {item}
            </a>)}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-122">
          {isMenuOpen ? <X size={24} data-id="element-123" /> : <Menu size={24} data-id="element-124" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white absolute top-full left-0 right-0 shadow-md py-4" data-id="element-125">
          <nav className="flex flex-col space-y-4 px-4" data-id="element-126">
            {['Home', 'About', 'Skills', 'Projects', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="font-medium hover:text-indigo-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-127">
                {item}
              </a>)}
          </nav>
        </div>}
    </header>;
};